import { Separator, type SeparatorProps } from '@radix-ui/react-separator';
import { styled } from 'styled-components';

type FuuzeDividerProps = SeparatorProps & {
  theme?: 'light' | 'dark';
};

export function FuuzeDivider({ theme = 'light', ...props }: FuuzeDividerProps) {
  return <SeparatorStyled $theme={theme} {...props} />;
}

const SeparatorStyled = styled(Separator)<{ $theme: FuuzeDividerProps['theme'] }>`
  min-height: 1px;
  background-color: ${props =>
    props.$theme === 'dark' ? props.theme.colors.dark.dark100 : props.theme.colors.dark.dark300};
  &[data-orientation='horizontal'] {
    height: 1px;
    width: 100%;
  }
  &[data-orientation='vertical'] {
    height: 100%;
    width: 1px;
  }
`;
